export default __webpack_public_path__ + "static/media/Hopscotch.9499cada.png";